/** Product version. Written by `pnpm version` via scripts/sync-version.mjs. Do not edit by hand. */
export const VERSION = '0.5.139' as const
